import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import qs from "query-string";
import { DemoFormVersion, getDemoFormCopy, DemoFormCopyContent } from "../constants/demoFormVersions";

export interface UseDemoFormVersion {
  version: DemoFormVersion;
  demoFormVersionValues: DemoFormCopyContent;
  isTwoStepsDemoForm: boolean;
}

export const DEMO_FORM_VERSION_QUERY_PARAM = "demo_form_version";

export const VERSION_MAP: Record<string, DemoFormVersion> = {
  "07251": DemoFormVersion.VERSION_07251,
  "07252": DemoFormVersion.VERSION_07252,
  "07253": DemoFormVersion.VERSION_07253,
  "07254": DemoFormVersion.VERSION_07254,
  "08252": DemoFormVersion.VERSION_08252
};

export const useDemoFormVersion = (): UseDemoFormVersion => {
  const location = useLocation();

  const result = useMemo(() => {
    const queryParams = qs.parse(location.search);
    const demoFormVersion = queryParams[DEMO_FORM_VERSION_QUERY_PARAM] as string;

    const version = VERSION_MAP[demoFormVersion] || DemoFormVersion.DEFAULT;

    return {
      version,
      isTwoStepsDemoForm: version === DemoFormVersion.VERSION_08252,
      demoFormVersionValues: getDemoFormCopy(version)
    };
  }, [location]);

  return result;
};
